module.exports = __webpack_public_path__ + "fbf73f7d66f6adb8f4bcc64eb4fc62e3.MP3";